import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.7', color: '#333' }}>
      <h1 style={{ color: '#1a6b4a' }}>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> June 1, 2026</p>
      <p>Welcome to <strong>Elite Goats</strong> ("we", "our", or "us"). We are committed to protecting your personal information and your right to privacy.</p>

      <h2>1. Information We Collect</h2>
      <p>We collect information you provide when registering or using our platform, including:</p>
      <ul>
        <li>Name, mobile number, and password</li>
        <li>Role (Customer, Farmer, or Butcher)</li>
        <li>Location and address details</li>
        <li>Product listings and transaction history</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To create and manage your account</li>
        <li>To process purchases and sales on the platform</li>
        <li>To verify farmers, butchers, and their listings</li>
        <li>To send order updates and notifications</li>
        <li>To improve our services</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We do not sell your personal data. We may share your information with:</p>
      <ul>
        <li>Other users as needed to complete transactions (e.g. seller contact details)</li>
        <li>Service providers who help us operate the platform</li>
        <li>Law enforcement if required by law</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure.</p>

      <h2>5. Your Rights</h2>
      <p>You have the right to access, update, or delete your personal information at any time by contacting us.</p>

      <h2>6. Account Deletion</h2>
      <p>You can delete your account at any time by following these steps:</p>
      <ol>
        <li>Log in to your Elite Goats account</li>
        <li>Go to your <strong>Profile</strong> page</li>
        <li>Scroll down to <strong>"Delete Account"</strong> section</li>
        <li>Click <strong>"Yes, Delete My Account"</strong> to confirm</li>
      </ol>
      <p>When you delete your account:</p>
      <ul>
        <li>Your profile and personal information will be permanently deleted</li>
        <li>Active orders will be cancelled</li>
        <li>Transaction history may be retained up to 90 days for legal compliance</li>
      </ul>
      <p>You can also email us at <strong>support@elitemeat.co.in</strong> to request deletion.</p>

      <h2>7. Children's Privacy</h2>
      <p>Our platform is not intended for users under the age of 18. We do not knowingly collect data from minors.</p>

      <h2>8. Changes to This Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of any changes by updating the effective date above.</p>

      <h2>9. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at:</p>
      <p>
        <strong>Elite Goats</strong><br />
        Email: support@elitemeat.co.in<br />
        Website: https://elitemeat.co.in
      </p>
    </div>
  );
};

export default PrivacyPolicy;